var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1067,
    height: 1067,
    viewBox: "3.55 3.55 1067 1067",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 533.5 533.5)",
    id: "98a0b6bc-763e-4506-8f8e-c05e4550b982"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -533.5,
    y: -533.5,
    rx: 0,
    ry: 0,
    width: 1067,
    height: 1067
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "7bb641b7-eeb9-4bef-bd23-f005da013049"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99 0 0 0.99 533.5 533.5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -58.67 -4.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2500, -2500)",
    d: "M 1100 2500 L 1100 1280 L 2500 1280 L 3900 1280 L 3900 1608 L 3900 1935 L 3868 1934 L 3835 1933 L 3832 1642 L 3830 1350 L 2500 1350 L 1170 1350 L 1170 2500 L 1170 3650 L 2468 3651 C 3181 3652 3780 3653 3798 3655 L 3830 3657 L 3830 3089 L 3830 2520 L 3865 2520 L 3900 2520 L 3900 3120 L 3900 3720 L 2500 3720 L 1100 3720 L 1100 2500 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -161.19 35.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1699.84, -2229.44)",
    d: "M 1650 2379 C 1560 2343 1521 2226 1573 2149 C 1610 2093 1654 2070 1722 2070 C 1754 2070 1796 2077 1815 2084 C 1850 2099 1850 2099 1850 2164 L 1850 2230 L 1820 2230 C 1791 2230 1790 2228 1790 2186 C 1790 2137 1781 2130 1721 2130 C 1677 2130 1635 2163 1624 2204 C 1616 2237 1636 2296 1663 2315 C 1691 2335 1760 2334 1789 2314 C 1810 2299 1813 2299 1832 2318 C 1844 2329 1849 2343 1845 2350 C 1824 2384 1707 2401 1650 2379 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -106.01 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2113, -2230)",
    d: "M 1990 2230 L 1990 2070 L 2113 2070 L 2236 2070 L 2236 2100 L 2236 2130 L 2148 2130 L 2060 2130 L 2060 2165 L 2060 2200 L 2135 2200 L 2210 2200 L 2210 2230 L 2210 2260 L 2135 2260 L 2060 2260 L 2060 2295 L 2060 2330 L 2145 2330 L 2230 2330 L 2230 2360 L 2230 2390 L 2110 2390 L 1990 2390 L 1990 2230 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -52.42 35.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2516.15, -2230.69)",
    d: "M 2435 2374 C 2385 2348 2362 2320 2350 2269 C 2322 2152 2404 2063 2532 2072 C 2751 2088 2734 2390 2513 2390 C 2487 2390 2452 2383 2435 2374 z M 2582 2305 C 2650 2238 2608 2130 2515 2130 C 2439 2130 2392 2214 2429 2283 C 2457 2335 2541 2347 2582 2305 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 10.73 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2990, -2230)",
    d: "M 2810 2230 L 2810 2070 L 2845 2070 L 2879 2070 L 2882 2162 L 2885 2255 L 2928 2182 C 2984 2088 2999 2088 3055 2185 L 3095 2255 L 3098 2163 L 3101 2070 L 3135 2070 L 3170 2070 L 3170 2230 L 3170 2390 L 3140 2390 C 3113 2390 3105 2381 3051 2290 L 2992 2190 L 2931 2290 C 2875 2380 2866 2390 2840 2390 L 2810 2390 L 2810 2230 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 70.25 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3435, -2230)",
    d: "M 3310 2230 L 3310 2070 L 3435 2070 L 3560 2070 L 3560 2100 L 3560 2130 L 3475 2130 L 3390 2130 L 3390 2165 L 3390 2200 L 3460 2200 L 3530 2200 L 3530 2230 L 3530 2260 L 3460 2260 L 3390 2260 L 3390 2295 L 3390 2330 L 3470 2330 L 3550 2330 L 3550 2360 L 3550 2390 L 3430 2390 L 3310 2390 L 3310 2230 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 117.53 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3790, -2230)",
    d: "M 3650 2360 C 3650 2331 3651 2330 3700 2330 L 3750 2330 L 3750 2200 L 3750 2070 L 3785 2070 L 3820 2070 L 3820 2200 L 3820 2330 L 3875 2330 C 3929 2330 3930 2330 3930 2360 L 3930 2390 L 3790 2390 L 3650 2390 L 3650 2360 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 168.88 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4175, -2230)",
    d: "M 4040 2230 L 4040 2070 L 4075 2070 C 4110 2070 4110 2070 4110 2115 C 4110 2160 4110 2160 4145 2160 C 4174 2160 4183 2154 4210 2115 C 4237 2076 4246 2070 4275 2070 C 4294 2070 4310 2073 4310 2076 C 4310 2079 4296 2101 4279 2126 L 4249 2171 L 4279 2199 C 4302 2221 4310 2237 4310 2264 C 4310 2354 4257 2390 4125 2390 L 4040 2390 L 4040 2230 z M 4222 2313 C 4267 2273 4231 2220 4158 2220 L 4110 2220 L 4110 2275 L 4110 2330 L 4157 2330 C 4186 2330 4210 2324 4222 2313 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 219.48 35.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4555, -2230)",
    d: "M 4400 2385 C 4400 2382 4427 2333 4460 2278 C 4513 2188 4520 2170 4520 2123 L 4520 2070 L 4555 2070 L 4590 2070 L 4590 2129 C 4590 2185 4594 2196 4650 2285 C 4683 2338 4710 2383 4710 2386 C 4710 2388 4694 2390 4675 2390 C 4643 2390 4638 2385 4600 2320 C 4578 2282 4558 2250 4556 2250 C 4554 2250 4534 2282 4511 2320 C 4472 2385 4467 2390 4435 2390 C 4416 2390 4400 2388 4400 2385 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -53.62 95.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2504.63, -1784.03)",
    d: "M 2460 1878 C 2432 1863 2422 1826 2441 1804 C 2447 1796 2473 1784 2498 1777 C 2555 1760 2574 1735 2546 1714 C 2523 1697 2477 1696 2448 1711 C 2432 1719 2429 1719 2432 1709 C 2445 1669 2554 1675 2572 1716 C 2589 1753 2573 1771 2507 1793 C 2466 1806 2450 1817 2450 1830 C 2450 1861 2476 1873 2527 1866 C 2560 1862 2571 1863 2564 1870 C 2547 1887 2487 1892 2460 1878 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -22.95 94.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2735, -1785)",
    d: "M 2650 1880 C 2650 1875 2666 1870 2685 1870 L 2720 1870 L 2720 1775 C 2720 1718 2724 1680 2730 1680 C 2736 1680 2740 1718 2740 1775 L 2740 1870 L 2780 1870 C 2802 1870 2820 1875 2820 1880 C 2820 1886 2785 1890 2735 1890 C 2685 1890 2650 1886 2650 1880 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 8.05 94.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2967.51, -1785)",
    d: "M 2916 1818 C 2945 1771 2960 1734 2960 1713 C 2960 1695 2965 1680 2970 1680 C 2976 1680 2980 1698 2980 1721 C 2980 1744 2988 1773 2998 1788 C 3039 1848 3061 1890 3051 1890 C 3046 1890 3026 1865 3008 1835 C 2990 1805 2972 1780 2968 1780 C 2964 1780 2946 1805 2928 1835 C 2910 1865 2890 1890 2883 1890 C 2877 1890 2891 1858 2916 1818 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 41.77 94.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3220, -1785)",
    d: "M 3150 1785 L 3150 1680 L 3220 1680 C 3260 1680 3290 1684 3290 1690 C 3290 1696 3263 1700 3230 1700 L 3170 1700 L 3170 1795 C 3170 1852 3166 1890 3160 1890 C 3154 1890 3150 1848 3150 1785 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 72.43 94.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3450, -1785)",
    d: "M 3380 1785 L 3380 1680 L 3450 1680 C 3490 1680 3520 1684 3520 1690 C 3520 1696 3493 1700 3460 1700 L 3400 1700 L 3400 1740 L 3400 1780 L 3455 1780 C 3485 1780 3510 1785 3510 1790 C 3510 1796 3485 1800 3455 1800 L 3400 1800 L 3400 1835 L 3400 1870 L 3460 1870 C 3493 1870 3520 1874 3520 1880 C 3520 1886 3490 1890 3450 1890 L 3380 1890 L 3380 1785 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 204.63)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 204.63)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 147.62 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99 0 0 0.48 593.25 398.75)",
    id: "9838a5e3-12d5-4378-9492-47813c608aba"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(79,242,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -37.46,
    y: -19.415,
    rx: 0,
    ry: 0,
    width: 74.92,
    height: 38.83
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.99 0.48 0 626.21 426.57)",
    id: "9838a5e3-12d5-4378-9492-47813c608aba"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(79,242,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -37.46,
    y: -19.415,
    rx: 0,
    ry: 0,
    width: 74.92,
    height: 38.83
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99 0 0 0.48 351.89 657.76)",
    id: "9838a5e3-12d5-4378-9492-47813c608aba"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(79,242,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -37.46,
    y: -19.415,
    rx: 0,
    ry: 0,
    width: 74.92,
    height: 38.83
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.99 -0.48 0 321.67 630.84)",
    id: "9838a5e3-12d5-4378-9492-47813c608aba"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(79,242,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -37.46,
    y: -19.415,
    rx: 0,
    ry: 0,
    width: 74.92,
    height: 38.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.8d7d09f6e549b19b0a1a5f971adb589e.svg";
export { ForwardRef as ReactComponent };